export const GridUiListDeleteHandler = (
  GridList,
  setGridList,
  index,
  onChange
) => {
  const newArr = GridList.slice(0, index).concat(GridList.slice(index + 1));
  setGridList(newArr);
  onChange("");
};
